import { MenuButton, Tooltip } from '@frameio/vapor';
import { IconInfo } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/OpenOnDesktopMenuButton';
import { useMountErrorMessage } from './hooks/useMountErrorMessage';
import { useOpenOnDesktopAction } from './hooks/useOpenOnDesktopAction';
import styles from './OpenOnDesktopMenuButton.module.css';

TEXT.DEFINE({
  /** Button label to mount a project */
  mountProject: 'Open on Desktop',
});

type OpenOnDesktopMenuButtonProps = {
  projectId: string;
  trackingSource?: string;
};

/**
 * Button to mount a project on the desktop.
 * @todo (FIND-2779): This probably should be moved near its consumer, ProjectMenu.
 *
 *
 * @param projectId - The ID of the project to mount.
 * @param rootFolderId - The ID of the root folder of the project.
 * @param trackingSource - The tracking source for the button press.
 */
export function OpenOnDesktopMenuButton({
  projectId,
  trackingSource = 'PROJECT_NAVIGATION',
}: OpenOnDesktopMenuButtonProps) {
  const { icon, isHidden, isDisabled, error, onPress } = useOpenOnDesktopAction(
    {
      projectId,
      trackingSource,
    }
  );
  const mountErrorMessage = useMountErrorMessage(error);

  if (isHidden) return null;

  return (
    <MenuButton
      disabled={isDisabled}
      iconAfter={
        isDisabled
          ? () => (
              <Tooltip placement="top" title={mountErrorMessage}>
                <span className={styles.infoIcon}>
                  <IconInfo size={16} />
                </span>
              </Tooltip>
            )
          : undefined
      }
      iconBefore={icon}
      label={TEXT.mountProject}
      onPress={onPress}
    >
      {TEXT.mountProject}
    </MenuButton>
  );
}
